import clsx from "clsx";
import type { FC } from "react";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { ChevronUpIcon } from "mds/icons";
import { ChevronDownIcon } from "mds/icons/ChevronDown";

interface BlockMoveButtonsProps {
  onMoveUp: () => void;
  onMoveDown: () => void;
  reachedTop: boolean;
  reachedBottom: boolean;
}

export const BlockMoveButtons: FC<BlockMoveButtonsProps> = ({
  onMoveUp,
  onMoveDown,
  reachedTop,
  reachedBottom,
}) => (
  <>
    {onMoveUp && (
      <Button
        className={clsx(
          "move-button cursor-pointer rounded-[4px] border-none text-black-tint-40 hover:text-black-tint-20",
          reachedTop && "disabled",
        )}
        disabled={reachedTop}
        kind="gray"
        size="s"
        title={t("tooltip.move_up")}
        onClick={onMoveUp}
      >
        <ChevronUpIcon className={clsx(reachedTop && "text-black-tint-70")} />
      </Button>
    )}

    {onMoveDown && (
      <Button
        className={clsx(
          "move-button mt-1 cursor-pointer rounded-[4px] border-none text-black-tint-40 hover:text-black-tint-20",
          reachedBottom && "disabled",
        )}
        disabled={reachedBottom}
        kind="gray"
        size="s"
        title={t("tooltip.move_down")}
        onClick={onMoveDown}
      >
        <ChevronDownIcon className={clsx(reachedBottom && "text-black-tint-70")} />
      </Button>
    )}
  </>
);
